import { PARTNER } from "@tm/isomorphic-utils";
import { usePartnerContext } from "@tm/static/partnerContext";
import { useBreakpointV2 } from "@tm/ui-widgets";
import React from "react";

import type { OrderDetailV2OrderDataProps } from "../../types";
import { OrderDataTable } from "../OrderDataTable";
import { OrderDataHeader } from "./OrderDataHeader";
import { OrderDataSeparator } from "./OrderDataSeparator";
import { OrderDataCard } from "./OrderDetailV2OrderData.style";

export const OrderDetailV2OrderData: React.FC<OrderDetailV2OrderDataProps> = ({
  insPlanName,
  insuranceInfo,
  insuranceType,
  orderDetailIcon,
  orderDetails,
  separatorColor,
}: OrderDetailV2OrderDataProps) => {
  const device = useBreakpointV2();
  const partner = usePartnerContext();
  const isGI = partner === PARTNER.GI;

  return (
    <OrderDataCard>
      <OrderDataHeader
        insPlanName={insPlanName}
        orderDetailIcon={orderDetailIcon}
        insuranceInfo={insuranceInfo}
        insuranceType={insuranceType}
      />
      {isGI && device === "lg" && <OrderDataSeparator color={separatorColor} />}
      <OrderDataTable orderDetails={orderDetails} />
    </OrderDataCard>
  );
};
